module.exports = __webpack_public_path__ + "img/EPF-24D-Goldregen-Studio-9615.560451ec.jpg";